import { Icon } from "@iconify/react";
import FraseRespuestaActions from "./FraseRespuestaActions";

const FraseRespuestaRow = ({ fraseRespuesta }) => {

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString("es-MX", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    } catch {
      return "N/A";
    }
  };

  return (
    <tr>
      <td>
        <div className="d-flex align-items-center gap-2">
          <Icon icon="mdi:message-reply-text" width="20" className="text-primary" />
          <span className="text-center" title={fraseRespuesta.frase}>
            {fraseRespuesta.frase}
          </span>
        </div>
      </td>
      <td>
        <span className="badge bg-info-600 text-white px-3 py-2">
          {fraseRespuesta.valor}
        </span>
      </td>
     
      <td>
        <span className="text-center text-neutral-700 text-xl">
          <FraseRespuestaActions fraseRespuesta={fraseRespuesta} />
        </span>
      </td>
    </tr>
  );
};

export default FraseRespuestaRow;
